module.exports = __webpack_public_path__ + "img/prize-type-2.8b230e41.png";